import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from 'react-grid-system';
import Map from '@Components/Map/Map';
import Divider from '@Components/Divider/Divider';
import Accordion from '@Components/Accordion/Accordion';
import ConditionalRender from '@Components/ConditionalRender/ConditionalRender';
import useTranslate from '@Utils/hooks/useTranslate';
import LabeledInformation from './LabeledInformation';
import { getInternetInstallationAddressSubtitleArgs } from '../util';
import {
	AccordionContentWrapper,
	SectionHeader,
	MapElement,
} from '@Components/Card/cards/ShippingDetails/ShippingDetails.styled';

const DeliveryDetailsHBBWFBB = ({ showMap }: { showMap: boolean }): JSX.Element => {
	const { translate } = useTranslate();
	const hbbWfbbProcessCheckout = useSelector(
		(state: types.redux.IState) => state.persistentCheckout.hbbWfbbProcessCheckout
	);
	const getInternetInstallationAddressSubtitle = () => {
		const args = getInternetInstallationAddressSubtitleArgs(hbbWfbbProcessCheckout);
		return translate(`shipping-details.accordion.contact-data.subtitle-${args.length}`, ...args);
	};

	return (
		<Accordion
			title={translate('shipping-details.accordion.title.delivery.details')}
			subtitle={getInternetInstallationAddressSubtitle()}
			icon="locationPinOutlined"
			accordionHeight={80}
		>
			<AccordionContentWrapper>
				<SectionHeader>
					{translate('shipping-details.accordion.internet-installation.section-header')}
				</SectionHeader>
				<Divider marginBottom={8} />
				<Row>
					<Col xs={12} sm={6}>
						<ConditionalRender
							show={!!hbbWfbbProcessCheckout?.region}
							onTrue={() => (
								<LabeledInformation
									label={translate('shipping-details.billing.shipping-data.data.governorate')}
									data={hbbWfbbProcessCheckout?.region}
								/>
							)}
						/>
						<ConditionalRender
							show={!!hbbWfbbProcessCheckout?.willyat}
							onTrue={() => (
								<LabeledInformation
									label={translate('shipping-details.billing.shipping-data.data.wilayat')}
									data={hbbWfbbProcessCheckout?.willyat}
								/>
							)}
						/>
						<ConditionalRender
							show={!!hbbWfbbProcessCheckout?.swatSOSStatus}
							onTrue={() => (
								<LabeledInformation
									label={translate('shipping-details.billing.shipping-data.data.city')}
									data={hbbWfbbProcessCheckout?.swatSOSStatus}
								/>
							)}
						/>
						<ConditionalRender
							show={!!hbbWfbbProcessCheckout?.wayNumber && hbbWfbbProcessCheckout?.wayNumber !== 'null'}
							onTrue={() => (
								<LabeledInformation
									label={translate('shipping-details.billing.shipping-data.data.way')}
									data={hbbWfbbProcessCheckout?.wayNumber}
								/>
							)}
						/>
						<ConditionalRender
							show={
								!!hbbWfbbProcessCheckout?.buildingNumber &&
								hbbWfbbProcessCheckout?.buildingNumber !== 'null'
							}
							onTrue={() => (
								<LabeledInformation
									label={translate('shipping-details.billing.shipping-data.data.house')}
									data={hbbWfbbProcessCheckout?.buildingNumber}
								/>
							)}
						/>
					</Col>

					<Col xs={12} sm={6}>
						{hbbWfbbProcessCheckout?.latitude && hbbWfbbProcessCheckout?.longitude && showMap && (
							<Map
								mapElement={<MapElement />}
								zoom={17}
								position={{
									lat: Number(hbbWfbbProcessCheckout.latitude),
									lng: Number(hbbWfbbProcessCheckout.longitude),
								}}
								markerPosition={{
									lat: Number(hbbWfbbProcessCheckout.latitude),
									lng: Number(hbbWfbbProcessCheckout.longitude),
								}}
								containerElement={<MapElement />}
								locked
							/>
						)}
					</Col>

					<Col sm={12} md={12}>
						<ConditionalRender
							show={!!hbbWfbbProcessCheckout?.landmark}
							onTrue={() => (
								<>
									<Divider withoutLine marginTop={40} />
									<LabeledInformation
										label={translate('shipping-details.billing.contact-data.data.landmark')}
										data={hbbWfbbProcessCheckout?.landmark}
									/>
								</>
							)}
						/>
					</Col>
				</Row>
			</AccordionContentWrapper>
		</Accordion>
	);
};

export default DeliveryDetailsHBBWFBB;
